var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-tree', _vm._b({ attrs: { "accordion": "", "current-node-key": _vm.currentValue }, on: { "current-change": _vm.handleCurrentChange }, scopedSlots: _vm._u([{ key: "default", fn: function fn(_ref) {
        var data = _ref.data;
        return _c('div', { staticClass: "tree-item" }, [_c('span', { staticClass: "radio", class: { select: _vm.currentNode === data } }), _vm._v(" "), _c('target-label', { attrs: { "imageStyle": _vm.imageStyle, "popDisabled": _vm.popDisabled, "eventItem": { node: data.uuid } } })], 1);
      } }]) }, 'el-tree', _vm.computedTreeProps, false));
};
var staticRenderFns = [];

export { render, staticRenderFns };